import React from 'react';
import { Row, Col, Icon } from 'antd'
import { PDFExport } from '@progress/kendo-react-pdf';
import logo from '../../images/logos/trackerapps.png'
import moment from 'moment'

class PDFLayout extends React.Component {

  render() {

    const { data } = this.props
    const styles = {
      text: {
        marginBottom: 0,
        lineHeight: 1.5
      },
      title: {
        color: 'black',
        margin: 0,
        fontSize: '22px',
        fontWeight: 'bold'
      },
      border: {
        border: '1px solid #4a90e2',
        padding: '0px 5px',
        marginBottom: 10,
        borderRadius: 5
      },
      info: {
        lineHeight: 1
      }
    }
    let total_atl_investigation = 0
    for (var cat in data.atlCategories) {
      total_atl_investigation = data.atlCategories[cat].Investigation + total_atl_investigation
    }
    let total_atl_reflection = 0
    for (var cat in data.atlCategories) {
      total_atl_reflection = data.atlCategories[cat].Reflection + total_atl_reflection
    }

    let perencDirectService = (data.type['Direct Service'] / data.totalProjects ) * 100
    let percentIndirectService = (data.type['Indirect Service'] / data.totalProjects ) * 100
    let percentAdvocacy = (data.type['Advocacy'] / data.totalProjects ) * 100
    let percentResearch = (data.type['Research'] / data.totalProjects ) * 100
    let percentNotEntered = (data.type['Not Entered'] / data.totalProjects ) * 100

// A4 HEIGHT : 784px
    return (
        <Row id='toExport' style={{ position: "absolute", border: '1px solid red',backgroundColor: 'white' ,top: 0, left: -2000 }}>
          <PDFExport
            paperSize={'A4'}
            fileName="Skill Export.pdf"
            title=""
            ref={(r) => this.toExport = r}>
            <div style={{width: 585, padding: 40}}>
              <div style={{borderRadius: 5, border: '1px solid #4a90e2', height: 120, marginBottom: 20, paddingTop: 10}}>
                <Col xs={6} style={{paddingLeft: 10}}>
                  <img style={{width: '65%', height: 'auto'}} src={logo} />
                </Col>
                <Col xs={15} style={{paddingLeft: 20}} >
                  <h3 style={Object.assign(styles.info, {marginTop: 5})}>{`${this.props.profile.profile.name} ${this.props.profile.profile.last_name}`}</h3>
                  <h3 style={styles.info}>{this.props.profile.profile.email}</h3>
                  <h3 style={styles.info}>{this.props.profile.profile.school.name}</h3>
                  <h3 style={styles.info}>{`Exported on ${moment().format('DD.MM.YYYY')}`}</h3>
                </Col>
              </div>

              <Row style={styles.border}>
                <Col xs={18}>
                  <h3 style={styles.text}>Total students</h3>
                </Col>
                <Col xs={6} style={{textAlign: 'right'}}>
                  <h3 style={styles.text}>{data.totalUsers}</h3>
                </Col>
              </Row>
              <Row style={styles.border}>
                <Col xs={18}>
                  <h3 style={styles.text}>Total projects</h3>
                </Col>
                <Col xs={6} style={{textAlign: 'right'}}>
                  <h3 style={styles.text}>{data.totalProjects}</h3>
                </Col>
              </Row>

              <h1 style={styles.title}>Total Number of Project Per Stage</h1>
              <table className="exportTable">
                <tr>
                  <th>Investigation</th>
                  <th>Preparation</th>
                  <th>Action</th>
                  <th>Demonstation</th>
                  <th>Reflection</th>
                  <th style={{backgroundColor: '#4a90e2', color: 'white', borderBottom: '1px solid white'}}>Completed</th>
                </tr>
                <tr>
                <th>{data.projectsPerStage.Investigation || 0}</th>
                <th>{data.projectsPerStage.Preparation || 0}</th>
                <th>{data.projectsPerStage.Action || 0}</th>
                <th>{data.projectsPerStage.Demonstration || 0}</th>
                <th>{data.projectsPerStage.Reflection || 0}</th>
                <td style={{backgroundColor: '#4a90e2', color: 'white'}}>{data.projectsPerStage.Completed}</td>
                </tr>
              </table>

              <h1 style={styles.title}>Type of Project</h1>
              <table className="exportTable">
                <tr>
                  <th style={{color: 'white', backgroundColor: '#4a90e2'}}></th>
                  <th>Direct Service</th>
                  <th>Indirect Service</th>
                  <th>Advocacy</th>
                  <th>Research</th>
                  <th>Not entered</th>
                </tr>
                <tr>
                  <td>Percentage</td>
                  <td>{perencDirectService.toFixed(2)}</td>
                  <td>{percentIndirectService.toFixed(2)}</td>
                  <td>{percentAdvocacy.toFixed(2)}</td>
                  <td>{percentResearch.toFixed(2)}</td>
                  <td>{percentNotEntered.toFixed(2)}</td>
                </tr>
                <tr>
                  <td>Amount</td>
                  <td>{data.type['Direct Service']}</td>
                  <td>{data.type['Indirect Service']}</td>
                  <td>{data.type['Advocacy']}</td>
                  <td>{data.type['Research']}</td>
                  <td>{data.type['Not Entered']}</td>
                </tr>
              </table>

            <h1 style={styles.title}>Total amount of learner attributes</h1>
              <table className="exportTable">
                <tr>
                  <th style={{width: '60%', color: 'white', backgroundColor: '#4a90e2'}}></th>
                  <th style={{width: '20%', color: 'white', backgroundColor: '#4a90e2'}}>Investigation</th>
                  <th style={{width: '20%', color: 'white', backgroundColor: '#4a90e2'}}>Reflection</th>
                </tr>
                <tr>
                  <th>Inquirers</th>
                  <th>{data.learnerProfile.Inquirers.Investigation}</th>
                  <th>3</th>
                </tr>
                <tr>
                  <th>Knowledgeable</th>
                  <th>{data.learnerProfile.Knowledgeable.Investigation}</th>
                  <th>{data.learnerProfile.Knowledgeable.Reflection}</th>
                </tr>
                <tr>
                  <th>Thinkers</th>
                  <th>{data.learnerProfile.Thinkers.Investigation}</th>
                  <th>{data.learnerProfile.Thinkers.Reflection}</th>
                </tr>
                <tr>
                  <th>Communicators</th>
                  <th>{data.learnerProfile.Communicators.Investigation}</th>
                  <th>{data.learnerProfile.Communicators.Reflection}</th>
                </tr>
                <tr>
                  <th>Principled</th>
                  <th>{data.learnerProfile.Principled.Investigation}</th>
                  <th>{data.learnerProfile.Principled.Reflection}</th>
                </tr>
                <tr>
                  <th>Open-Minded</th>
                  <th>{data.learnerProfile['Open-Minded'].Investigation}</th>
                  <th>{data.learnerProfile['Open-Minded'].Reflection}</th>
                </tr>
                <tr>
                  <th>Caring</th>
                  <th>{data.learnerProfile.Caring.Investigation}</th>
                  <th>{data.learnerProfile.Caring.Reflection}</th>
                </tr>
                <tr>
                  <th>Risk-Takers</th>
                  <th>{data.learnerProfile['Risk-Takers'].Investigation}</th>
                  <th>{data.learnerProfile['Risk-Takers'].Reflection}</th>
                </tr>
                <tr>
                  <th>Balanced</th>
                  <th>{data.learnerProfile.Balanced.Investigation}</th>
                  <th>{data.learnerProfile.Balanced.Reflection}</th>
                </tr>
                <tr>
                  <th>Reflective</th>
                  <th>{data.learnerProfile.Reflective.Investigation}</th>
                  <th>{data.learnerProfile.Reflective.Reflection}</th>
                </tr>
              </table>


              <h1 style={styles.title}>Total Amount of ATL Category</h1>
              <table className="exportTable">
                <tr>
                  <th style={{ color: 'white', backgroundColor: '#4a90e2'}}></th>
                  <th style={{ color: 'white', backgroundColor: '#4a90e2'}}>Investigation (%)</th>
                  <th style={{ color: 'white', backgroundColor: '#4a90e2'}}>Investigation (pcs)</th>
                  <th style={{ color: 'white', backgroundColor: '#4a90e2'}}>Reflection (%)</th>
                  <th style={{ color: 'white', backgroundColor: '#4a90e2'}}>Reflection (pcs)</th>
                </tr>
                <tr>
                  <th>Research</th>
                  <th>{((data.atlCategories.Research.Investigation / total_atl_investigation) * 100).toFixed(2)}</th>
                  <th>{data.atlCategories.Research.Investigation}</th>
                  <th>{(data.atlCategories.Research.Reflection / total_atl_reflection).toFixed(2) * 100}</th>
                  <th>{data.atlCategories.Research.Reflection}</th>
                </tr>
                <tr>
                  <th>Thinking</th>
                  <th>{((data.atlCategories.Thinking.Investigation / total_atl_investigation) * 100).toFixed(2)}</th>
                  <th>{data.atlCategories.Thinking.Investigation}</th>
                  <th>{(data.atlCategories.Thinking.Reflection / total_atl_reflection).toFixed(2) * 100}</th>
                  <th>{data.atlCategories.Thinking.Reflection}</th>
                </tr>
                <tr>
                  <th>Self-Management</th>
                  <th>{((data.atlCategories['Self-Management'].Investigation / total_atl_investigation).toFixed(2) * 100).toFixed(2)}</th>
                  <th>{data.atlCategories['Self-Management'].Investigation}</th>
                  <th>{(data.atlCategories['Self-Management'].Reflection / total_atl_reflection).toFixed(2) * 100}</th>
                  <th>{data.atlCategories['Self-Management'].Reflection}</th>
                </tr>
                <tr>
                  <th>Social</th>
                  <th>{((data.atlCategories.Social.Investigation / total_atl_investigation).toFixed(2) * 100).toFixed(2)}</th>
                  <th>{data.atlCategories.Social.Investigation}</th>
                  <th>{(data.atlCategories.Social.Reflection / total_atl_reflection).toFixed(2) * 100}</th>
                  <th>{data.atlCategories.Social.Reflection}</th>
                </tr>
                <tr>
                  <th>Communication</th>
                  <th>{((data.atlCategories.Communication.Investigation / total_atl_investigation).toFixed(2) * 100).toFixed(2)}</th>
                  <th>{data.atlCategories.Communication.Investigation}</th>
                  <th>{(data.atlCategories.Communication.Reflection / total_atl_reflection).toFixed(2) * 100}</th>
                  <th>{data.atlCategories.Communication.Reflection}</th>
                </tr>
              </table>

              <h1 style={styles.title}>Total number of relevant service learning outcomes selected in projects.</h1>

              <table className="exportTable">
                <tr>
                  <th style={{ width: '80%', color: 'white', backgroundColor: '#4a90e2'}}></th>
                  <th style={{ color: 'white', backgroundColor: '#4a90e2'}}>Amount</th>
                </tr>
                <tr>
                  <th className="left">Become more aware of their own strengths and areas for growth</th>
                  <th>{data.learningOutcomes['become more aware of their own strengths and areas for growth']}</th>
                </tr>
                <tr>
                  <th className="left">Discuss, evaluate and plan student-initiated activities</th>
                  <th>{data.learningOutcomes['discuss, evaluate and plan student-initiated activities']}</th>
                </tr>
                <tr>
                  <th className="left">Persevere in action</th>
                  <th>{data.learningOutcomes['persevere in action']}</th>
                </tr>
                <tr>
                  <th className="left">Work collaboratively with others</th>
                  <th>{data.learningOutcomes['work collaboratively with others']}</th>
                </tr>
                <tr>
                  <th className="left">Develop international-mindedness through global engagement, <br />  multilingualism and intercultural understanding</th>
                  <th>{data.learningOutcomes['develop international-mindedness through global engagement, multilingualism and intercultural understanding']}</th>
                </tr>
                <tr>
                  <th className="left">Undertake challenges that develop new skill</th>
                  <th>{data.learningOutcomes['undertake challenges that develop new skills']}</th>
                </tr>
                <tr>
                  <th className="left">Consider the ethical implications of their actions</th>
                  <th>{data.learningOutcomes['consider the ethical implications of their actions']}</th>
                </tr>
              </table>

            </div>
            </PDFExport>
      </Row>
    )
  }
}

export default PDFLayout;



// WEBPACK FOOTER //
// ./src/components/PDFLayout/serviceTracker.jsx